import * as React from "react";
import {
    Authenticator,
    Capability,
    CapabilityManager,
    ICapabilities,
    WhenCapable
    } from "../../components/security";
import { Redirect, Route, RouteProps } from "react-router";
import { Unsubscribable } from "rxjs";

interface IState
{
    capabilities?: ICapabilities;
}

export interface IPrivateRouteProps extends RouteProps
{
    component: React.ComponentClass<any>;
    capability?: Capability;
    unauthenticatedPath: string;
    missingCapabilityPath?: string;
}

export default class PrivateRoute extends React.Component<IPrivateRouteProps, IState>
{
    private _capabilityManagerSubscription: Unsubscribable;

    constructor(props: IPrivateRouteProps)
    {
        super(props);
        this.state = {};

        CapabilityManager.has(this.props.capability);
    }

    public render()
    {
        // tslint:disable-next-line:variable-name
        const { component: Component, ...rest } = this.props;

        return (
            <Route
                {...rest}
                // tslint:disable-next-line:jsx-no-lambda
                render={props =>
                {
                    if (!this.state.capabilities)
                    {
                        return null;
                    }

                    return Authenticator.isLoggedIn && this.state.capabilities.has(this.props.capability)
                        ? (
                            <Component {...props} />
                        )
                        : (
                            <Redirect
                                to={{
                                    pathname: Authenticator.isLoggedIn
                                        ? this.props.missingCapabilityPath || this.props.unauthenticatedPath
                                        : this.props.unauthenticatedPath,
                                    state: { from: props.location }
                                }}
                            />
                        );
                }
                } />
        );
    }

    public componentWillMount()
    {
        this._capabilityManagerSubscription = CapabilityManager.subscribe(capabilities => this.setState({ capabilities }));
    }

    public componentWillUnmount()
    {
        if (this._capabilityManagerSubscription)
        {
            this._capabilityManagerSubscription.unsubscribe();
        }
    }
}
